import React from 'react';

// http(s) links, without a trailing punctuation mark ("see https://x.com." -> the dot stays text)
const URL_PATTERN = /(https?:\/\/[^\s<>"']*[^\s<>"'.,;:!?)\]])/g;

/**
 * Plain text with its http(s) links clickable - opened in a new tab. Only text nodes and <a> are rendered, never
 * HTML from the text, so a comment can't inject markup. Line breaks are kept (white-space: pre-wrap).
 */
const LinkifiedText: React.FC<{ text?: string | null; className?: string }> = ({ text, className }) => {
  if (!text) {
    return null;
  }
  const parts = text.split(URL_PATTERN);
  return (
    <span className={`linkified-text ${className || ''}`}>
      {parts.map((part, index) =>
        index % 2 === 1 ? (
          <a key={index} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        ) : (
          <React.Fragment key={index}>{part}</React.Fragment>
        )
      )}
    </span>
  );
};

export default LinkifiedText;
